// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__o5JGq","second_bg":"Hero_second_bg__ZXrhl","default_hero":"Hero_default_hero__KP+F-"};